// Variabili globali
window.galleryState = {
    lastWidth: 0,
    resizeTimeout: null
};

$(document).on('zg.gallery.rendered', function(event, $element) {
    var splideElement = $element.find('.splide')[0];
    if (!splideElement) return;

    function initSplide() {
        var currentWidth = $(window).width();
        var isMobileView = (typeof IS_MOBILE !== 'undefined' && IS_MOBILE) || currentWidth < 768;

        // Anti-Loop check
        var widthDiff = Math.abs(currentWidth - window.galleryState.lastWidth);
        if (splideElement.splide && widthDiff < 30) return; 
        window.galleryState.lastWidth = currentWidth;

        // Reset istanza
        if (splideElement.splide) splideElement.splide.destroy(true);

        // Pulizia DOM
        $(splideElement).find('.splide__arrows').remove();
        $(splideElement).find('.splide__custom-toggle').remove();

        // Icone SVG
        var iconPause = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
        var iconPlay  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';

        // Iniezione HTML
        if (isMobileView) {
            // Frecce Mobile
            var svgPrev = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="square" d="m7.5 5 5 5-5 5"></path></svg>';
            var svgNext = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="square" d="m7.5 5 5 5-5 5"></path></svg>';
            var arrowsHTML = '<div class="splide__arrows"><button class="splide__arrow splide__arrow--prev">' + svgPrev + '</button><button class="splide__arrow splide__arrow--next">' + svgNext + '</button></div>';
            $(splideElement).append(arrowsHTML);
        } else {
            // Tasto Desktop: Aggiungiamo la classe 'is-playing' subito perché l'autoscroll è attivo di default
            var toggleBtnHTML = '<div class="splide__custom-toggle_container"><button type="button" class="splide__custom-toggle is-playing" aria-label="Pausa scorrimento"><div>' + iconPause + '</button></div>';
            $(splideElement).append(toggleBtnHTML);
        }

        // Opzioni
        var splideOptions = {
            type        : isMobileView ? 'slide' : 'loop',
            drag        : true,
            focus       : 'center',
            autoWidth   : !isMobileView,
            autoHeight  : false,
            gap         : '0px',
            arrows      : isMobileView,
            pagination  : !isMobileView,
            updateOnMove: true,
            waitForTransition: false,
            autoScroll  : isMobileView ? false : { speed: 1, pauseOnHover: false }
        };

        var splide = new Splide(splideElement, splideOptions);

        // Montaggio e Binding Eventi
        window.requestAnimationFrame(function() {
            splide.mount(window.splide.Extensions);
            splideElement.splide = splide;

            // --- GESTIONE CLICK TASTO PAUSA (Solo Desktop) ---
            if (!isMobileView) {
                var $toggleBtn = $(splideElement).find('.splide__custom-toggle');
                
                // Rimuoviamo eventuali eventi precedenti per sicurezza
                $toggleBtn.off('click').on('click', function() {
                    var AutoScroll = splide.Components.AutoScroll;
                    var $this = $(this);

                    // Usiamo la classe del bottone come "fonte di verità"
                    // Se ha la classe 'is-playing', significa che sta andando e l'utente vuole PAUSA.
                    if ($this.hasClass('is-playing')) {
                        AutoScroll.pause();
                        $this.removeClass('is-playing').addClass('is-paused');
                        $this.html(iconPlay);
                        $this.attr('aria-label', 'Avvia scorrimento');
                    } else {
                        // Altrimenti vuole PLAY
                        AutoScroll.play();
                        $this.removeClass('is-paused').addClass('is-playing');
                        $this.html(iconPause);
                        $this.attr('aria-label', 'Pausa scorrimento');
                    }
                });
            }
        });
    }

    // Debounce
    clearTimeout(window.galleryState.resizeTimeout);
    window.galleryState.resizeTimeout = setTimeout(function() {
        initSplide();
    }, 100);
});


$(document).ready(function() {
    
    // Al click del tasto X
    $('.btn-gallery-mobile a').on('click', function(e) {
        e.preventDefault(); // Evita il comportamento standard del link

        // Calcola la posizione (offset) dell'elemento .table-product
        var targetPosition = $(".table-product").offset().top - 95;

        // Esegue l'animazione dello scroll
        $('html, body').animate({
            scrollTop: targetPosition
        }, 500); // DURATA: 2500 millisecondi (2.5 secondi)
    });

});